import React, { useEffect, useState } from "react";

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    // Get visitor count from localStorage
    const count = localStorage.getItem("visitorCount");

    // Increment the count or initialize it
    const newCount = count ? parseInt(count) + 1 : 1;
    
    // Update localStorage
    localStorage.setItem("visitorCount", newCount);
    
    // Update state
    setVisitorCount(newCount);
  }, []);

  return (
    <div style={styles.container}>
      <h3 style={styles.text}>Total Applied: {visitorCount}</h3>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    marginTop: "20px",
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#f4f4f4",
    width: "200px",
    margin: "auto"
  },
  text: {
    fontSize: "18px",
    color: "#333",
  }
};

export default VisitorCounter;
